module.exports = __webpack_public_path__ + "img/ic-reg-success.87005ba6.svg";